export const SELECTED_LECTURES_DSP_NMORD = 'timeTableLectures/SELECTED_LECTURES_DSP_NMORD';